import { DialogActions, styled } from '@mui/material';
import colors from '@sweep-io/sweep-design/dist/colors';

export const StyledDialogActions = styled(DialogActions)`
  padding: 16px 24px;
  border-top: 1px solid ${colors.grey[120]};
  justify-content: flex-end;
`;
